import { TournamentAdmin } from '../models';
import { TournamentAdminRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetTournamentAdminsUseCase {
  constructor(private tournamentAdminRepository: TournamentAdminRepository) {}

  async execute(tournamentId: string): Promise<TournamentAdmin[]> {
    logger.debug('GetTournamentAdmins', 'Getting admins for tournament', { tournamentId });

    const admins = await this.tournamentAdminRepository.getByTournamentId(tournamentId);

    logger.debug('GetTournamentAdmins', 'Found admins', { count: admins.length });

    return admins;
  }
}